import { render, staticRenderFns } from "./notRegisteredCustInfo.vue?vue&type=template&id=5df6472a&scoped=true&"
import script from "./notRegisteredCustInfo.vue?vue&type=script&lang=js&"
export * from "./notRegisteredCustInfo.vue?vue&type=script&lang=js&"
import style0 from "./notRegisteredCustInfo.vue?vue&type=style&index=0&id=5df6472a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df6472a",
  null
  
)

export default component.exports